import { ContentCopyTwoTone, DownloadTwoTone } from "@mui/icons-material";
import { Button, Paper, Stack, Typography } from "@mui/material";

export default function ActionBar({
  isCopySupported,
  onCopy,
  onDownload,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, sm: 2.25 },
        borderRadius: { xs: 3, sm: 4 },
        border: (theme) => `1px solid ${theme.palette.outline?.main}`,
      }}
    >
      <Stack spacing={2}>
        <Stack spacing={0.5}>
          <Typography variant="overline" color="text.secondary">
            Export / 导出
          </Typography>
          <Typography variant="h6">Take the sticker with you</Typography>
          <Typography variant="body2" color="text.secondary">
            Copy 适合直接粘贴到聊天窗口，Download 更适合保存原图。
          </Typography>
        </Stack>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.25}>
          <Button
            variant="outlined"
            size="large"
            startIcon={<ContentCopyTwoTone />}
            onClick={onCopy}
            disabled={!isCopySupported}
            fullWidth
          >
            Copy / 复制
          </Button>
          <Button
            variant="contained"
            size="large"
            startIcon={<DownloadTwoTone />}
            onClick={onDownload}
            fullWidth
          >
            Download / 下载
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
